var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50669 17.9999C7.31458 18.0006 7.12476 17.9582 6.95118 17.8759C6.77761 17.7935 6.62469 17.6734 6.50366 17.5242L0.292537 9.81068C0.103398 9.58065 0 9.29211 0 8.99433C0 8.69656 0.103398 8.40802 0.292537 8.17798L6.72227 0.464424C6.94054 0.201884 7.2542 0.0367824 7.59423 0.00543999C7.93427 -0.0259024 8.27284 0.0790816 8.53545 0.297296C8.79806 0.515511 8.96321 0.829082 8.99456 1.16903C9.02591 1.50897 8.9209 1.84744 8.70262 2.10998L2.95444 9.00076L8.50973 15.8915C8.66698 16.0802 8.76687 16.31 8.79758 16.5537C8.82828 16.7974 8.78853 17.0448 8.68301 17.2666C8.57749 17.4884 8.41062 17.6753 8.20216 17.8053C7.99369 17.9352 7.75235 18.0028 7.50669 17.9999Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBack);
export default __webpack_public_path__ + "static/media/home_back.a5a72ab113b91c0b8be47f979ba867ba.svg";
export { ForwardRef as ReactComponent };